<div class="stepper d-flex h-100 flex-column">
    <nz-steps [nzCurrent]="current">
      <nz-step *ngFor="let step of steps" [nzTitle]="step.title"></nz-step>
    </nz-steps>
  
    <div class="steps-content overflow-auto flex-fill mt-3">
      <span class="header-5">{{steps[current]?.data?.display_name}}</span>
      <ng-container
        *ngComponentOutlet="
          steps[current]?.component;
          injector: stepInjectors[current]
        "
      ></ng-container>
    </div>
    <div class="steps-action d-flex justify-content-end mt-3 gap-3 mx-3">
      <button
        *ngIf="current > 0"
        class="btn btn-accello-primary"
        (click)="previous()"
      >
        <span>Previous</span>
      </button>
      <button
        *ngIf="current < steps.length - 1"
        class="btn btn-accello-primary"
        (click)="next()"
      >
        <span>Next</span>
      </button>
      <button
        *ngIf="current === steps.length - 1"
        class="btn btn-accello-primary"
        (click)="done()"
      >
        <span>Done</span>
      </button>
    </div>
  </div>
  